/* tslint:disable */
import { DmsApiConfiguration } from './dms-api-configuration';
import { HttpClient } from '@angular/common/http';

/**
 * Base class for services
 */
export class BaseClient {
  constructor(
    protected config: DmsApiConfiguration,
    protected http: HttpClient
  ) {
  }

  private _rootUrl: string = '';

  /**
   * Returns the root url for all operations in this service. If not set directly in this
   * service, will fallback to `DmsApiConfiguration.rootUrl`.
   */
  get rootUrl(): string {
    return this._rootUrl || this.config.rootUrl;
  }

  /**
   * Sets the root URL for API operations in this service.
   */
  set rootUrl(rootUrl: string) {
    this._rootUrl = rootUrl;
  }
}
